<template>
  <div class="history">
    <div class="top">
      <Input
        v-model="searchVal"
        clearable
        placeholder="enter and search..."
        style="width: 200px"
        @on-enter="seachHisory"
      />
      <div class="right">
        <Button icon="md-close-circle" @click="clearHistory">Clear</Button>
        <!-- <Button disabled icon="md-cloud-download">Export</Button
        ><Button disabled icon="md-cloud-upload">Import</Button> -->
      </div>
    </div>
    <div class="bottom">
      <div v-if="historyList.length == 0" class="result">查询历史记录为空</div>
      <div v-else class="historyCard">
        <Card>
          <p
            v-for="item in historyList"
            :key="item.id"
            @click="selectRow(item)"
          >
            <a href="#">
              <span>{{ item.createTime }}</span>
              <span
                ><Icon :type="item.success ? 'md-checkmark' : 'md-close'" />
              </span>
              <span>{{ item.name }}</span>
              <span>{{ item.content }}</span>
            </a>
          </p>

          <!-- <Page
            style="margin-top: 10px; display: flex; justify-content: flex-end"
            :total="historyList.page.count"

            :page-size="pageSize"
            @on-change="chgPage"
          /> -->
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/libs/api";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      searchVal: "",
      page: 1,
      pageSize: 10,
      historyList: [], //查询历史
    };
  },
  created() {},
  components: {},
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
    }),
  },
  watch: {
    historyList () {
      this.page = 1
    }
  },
  mounted() {
    // 查询历史
    // let param = {
    //   projectId: this.projectId,
    //   page: this.page,
    //   pageSize: this.pageSize,
    // };
    this.getHistory();
  },
  methods: {
    // 查询历史单击回显
    selectRow(item) {
      // 判断是否有name
      if (item.name) {
        this.$emit("selectRowUpdate", item);
      } else {
        // console.log(222);
        this.$emit("selectRow", item);
      }
    },
    // 清空历史
    clearHistory() {
      api.delHistory(this.projectId).then((res) => {
        // let param = {
        //   projectId: this.projectId,
        //   page: this.page,
        //   pageSize: this.pageSize,
        // };
        this.getHistory();
      });
    },

    // 分页
    chgPage(index) {
      // 查询历史
      // let param = {
      //   projectId: this.projectId,
      //   page: index,
      //   pageSize: this.pageSize,
      // };
      this.getHistory();
    },
    // 查询历史
    getHistory() {
      api.getHistory(this.projectId).then((res) => {
        if (res.data.status == 1) {
          if (res.data.fields.list) {
            res.data.fields.list.forEach((item) => {
              item.createTime = this.calculateDiffTime(
                item.createTime,
                new Date().getTime()
              );
            });

            if (this.searchVal) {
              this.historyList = res.data.fields.list.filter((item) => {
                if (item.name) {
                  return (
                    item.createTime
                      .toLowerCase()
                      .indexOf(this.searchVal.toLowerCase()) != -1 ||
                    item.content
                      .toLowerCase()
                      .indexOf(this.searchVal.toLowerCase()) != -1 ||
                    item.name
                      .toLowerCase()
                      .indexOf(this.searchVal.toLowerCase()) != -1
                  );
                } else {
                  return (
                    item.createTime
                      .toLowerCase()
                      .indexOf(this.searchVal.toLowerCase()) != -1 ||
                    item.content
                      .toLowerCase()
                      .indexOf(this.searchVal.toLowerCase()) != -1
                  );
                }
              });
            } else {
              this.historyList = res.data.fields.list;
            }
          } else {
            this.historyList = [];
          }
        } else {
          this.historyList = [];
        }
      });
    },

    // 格式化时间
    calculateDiffTime(startTime, endTime) {
      let runTime = parseInt((endTime - startTime) / 1000);
      let year = Math.floor(runTime / 86400 / 365);
      runTime = runTime % (86400 * 365);
      let month = Math.floor(runTime / 86400 / 30);
      runTime = runTime % (86400 * 30);
      let day = Math.floor(runTime / 86400);
      runTime = runTime % 86400;
      let hour = Math.floor(runTime / 3600);
      runTime = runTime % 3600;
      let minute = Math.floor(runTime / 60);
      runTime = runTime % 60;
      let second = runTime;

      if (year > 0) {
        return `${year} years ago`;
      } else if (month > 0) {
        return `${month} months ago`;
      } else if (day > 0) {
        return `${day} day ago`;
      } else if (hour > 0) {
        return `${hour} hour ago`;
      } else if (minute > 0) {
        return `${minute} minutes ago`;
      } else if (second > 0) {
        return `${second} seconds ago`;
      } else {
        return "now";
      }
      // let result = { year, month, day, hour, minute, second };
      // console.log(
      //   `相差${year}年${month}月${day}天${hour}小时${minute}分${second}秒`
      // );
      // console.log(result, "resu lt");
      // return result;
    },
    // 搜索
    seachHisory() {
      let timer;
      clearTimeout(timer);

      timer = setTimeout(() => {
        this.getHistory();
      }, 1000);
    },
  },
};
</script>

<style scoped>
.history {
  padding: 0 10px;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right Button {
  color: #0084FF;
  margin-left: 12px;
}
.result {
  font-size: 30px;
  color: #d6d8db;
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
p a {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
p a span {
  display: block;
}
p a span:nth-child(1) {
  width: 120px;
  color: #838b92;
}
p a span:nth-child(2) {
  width: 50px;
  color: #838b92;
  font-size: 18px;
}
p a span:nth-child(3) {
  width: 120px;
  color: #838b92;
  font-size: 12px;
}
p a span:nth-child(4) {
  width: 600px;
  font-size: 12px;
}
.historyCard {
  padding: 5px 0;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/history.vue